import { render } from "./newCounselConfirm.vue?vue&type=template&id=080e2a3e&ts=true"
import script from "./newCounselConfirm.vue?vue&type=script&lang=ts&config=true"
export * from "./newCounselConfirm.vue?vue&type=script&lang=ts&config=true"

import "./newCounselConfirm.vue?vue&type=style&index=0&id=080e2a3e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__